export const env = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL as string | undefined,
  supabasePubKey: import.meta.env.VITE_SB_PUBLISHABLE_KEY as string | undefined,
  appUrl: (import.meta.env.VITE_APP_URL as string | undefined) ?? 'http://localhost:5173',
  turnstileSiteKey: import.meta.env.VITE_TURNSTILE_SITE_KEY as string | undefined,
  gitHash: import.meta.env.VITE_GIT_HASH as string | undefined,
}

export const isSupabaseConfigured = Boolean(env.supabaseUrl && env.supabasePubKey)
